// extracted by mini-css-extract-plugin
export default {"obraL2":"ObraL2_obraL2__bCXma","cards":"ObraL2_cards__hRv-t","bigCard":"ObraL2_bigCard__wMRGV","card":"ObraL2_card__IM2cf","map":"ObraL2_map__0Fzo7"};